export default "__VITE_ASSET__04dde8d2__"